import React, { useState } from "react";

// Ant Design
import { Table, Row, Col, Button, Layout, Popconfirm, message } from "antd";
import SelectedMetrics from "../components/SelectedMetricList";
import AudienceDetails from "../components/AudienceDetails";

import { demographicsAudienceTableColumn } from "../utils/tableColumns";

const { Footer } = Layout;

const DemographicslMainView = props => {
  const {
    audienceDemographs,
    handleFetchAudienceDemographs,
    deleteAudience,
  } = props;

  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleDelete = async id => {
    try {
      setLoading(true);
      await deleteAudience(id);
      await handleFetchAudienceDemographs();
      message.success("Audience has been archived", 2);
      setLoading(false);
    } catch (error) {
      message.error("Failed to delete audience", 2);
    }
  };

  const defaultExpandable = {
    expandedRowRender: record => {
      const { metrics } = record;
      return (
        <>
          <Row style={{ minHeight: "700px" }} gutter={16}>
            <Col span={6}>
              <SelectedMetrics list={metrics}></SelectedMetrics>
            </Col>
            <Col span={18} style={{ height: "700px" }}>
              <AudienceDetails audienceDetails={record} />
              <Footer>
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => {
                    handleDelete(record.id);
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button loading={loading}>Archive</Button>
                </Popconfirm>
              </Footer>
            </Col>
          </Row>
        </>
      );
    },
  };

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const tableProps = {
    rowSelection,
    expandable: defaultExpandable,
  };

  return (
    <Table
      {...tableProps}
      columns={demographicsAudienceTableColumn}
      style={{ height: "600px" }}
      dataSource={audienceDemographs.map(i => ({ ...i, key: i.id }))}
    />
  );
};

export default DemographicslMainView;
